module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-1db0ddd81a72cd1a9a57df2525fab9c3.png";